import React, { useEffect, useState } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import TimePicker from 'components/TimePicker';
import Slider from "components/Slider";
import { useQuery } from "@apollo/client";
import { GET_ALL_HOTEL_CHARGES } from "graphql/service";
import { Content, ItemContainer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";
import moment from "moment-timezone";
import { TIME_ZONE } from "constants/constant";
import colors from "constants/colors";

const RatePlan = () => {

  const [hotelCharges, setHotelCharges] = useState([]);

  const { data: hotelChargesData, error } = useQuery(GET_ALL_HOTEL_CHARGES);

  useEffect(() => {
    if (hotelChargesData) {
      setHotelCharges(hotelChargesData.hotelCharges);
    }
  }, [hotelChargesData]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  return (
    <Card 
      additionalstyle={`
        height: auto;
        align-self: flex-start;
      `}
    >
      <CardHeader>
        <div className="type">HOTEL CHARGES</div>
      </CardHeader>
      <Content>
        <ItemContainer>
          <div className="title">Check-In/Check-Out</div>
          <div className="values">
            <div className="valueContainer">
              <div className="label">CHECK-IN TIME</div>
              <TimePicker
                className="checkInTime"
                TimeValue={moment(hotelCharges.checkInDate).tz(TIME_ZONE)}
                setTime={(time) => {
                  setHotelCharges({
                    ...hotelCharges,
                    checkInDate: time,
                  })
                }}
                additionalstyle={`
                  width: 100%;
                  min-width: 110px;
                  border: 1px solid ${colors.darkGrey};

                  input {
                    padding-right: 26px;
                  }
                `}
              />
            </div>
            <div className="valueContainer">
              <div className="label">CHECK-OUT TIME</div>
              <TimePicker
                className="checkOutTime"
                TimeValue={moment(hotelCharges.checkOutDate).tz(TIME_ZONE)}
                setTime={(time) => {
                  setHotelCharges({
                    ...hotelCharges,
                    checkOutDate: time,
                  })
                }}
                additionalstyle={`
                  width: 100%;
                  min-width: 110px;
                  border: 1px solid ${colors.darkGrey};

                  input {
                    padding-right: 26px;
                  }
                `}
              />
            </div>
          </div>
        </ItemContainer>
        <ItemContainer>
          <div className="title">
            <span className="text">Quiet Hours</span>
            <span className="slider">
              <Slider
                checked={hotelCharges.quietHoursEnabled}
                onActivate={() => setHotelCharges({
                  ...hotelCharges,
                  quietHoursEnabled: true,
                })}
                onDeactivate={() => setHotelCharges({
                  ...hotelCharges,
                  quietHoursEnabled: false,
                })}
              />
            </span>
          </div>
          <div className="values">
            <div className="valueContainer">
              <div className="label">START TIME</div>
              <TimePicker
                className="checkInTime"
                TimeValue={moment(hotelCharges.checkInDate).tz(TIME_ZONE)}
                setTime={(time) => {
                  setHotelCharges({
                    ...hotelCharges,
                    checkInDate: time,
                  })
                }}
                additionalstyle={`
                  width: 100%;
                  min-width: 110px;
                  border: 1px solid ${colors.darkGrey};

                  input {
                    padding-right: 26px;
                  }
                `}
              />
            </div>
            <div className="valueContainer">
              <div className="label">END TIME</div>
              <TimePicker
                className="checkOutTime"
                TimeValue={moment(hotelCharges.checkOutDate).tz(TIME_ZONE)}
                setTime={(time) => {
                  setHotelCharges({
                    ...hotelCharges,
                    checkOutDate: time,
                  })
                }}
                additionalstyle={`
                  width: 100%;
                  min-width: 110px;
                  border: 1px solid ${colors.darkGrey};

                  input {
                    padding-right: 26px;
                  }
                `}
              />
            </div>
          </div>
        </ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
      </Content>
    </Card>
  );
};

export default RatePlan;
